<div class="col-12 mt-3 p-2 alert-box">
  <div class="alert alert-success d-flex align-items-center" role="alert">
    <i class="material-icons">warning_amber</i> 
    <span class="mx-2 font-bold">{{initLabel}}</span>
    <span>{{label}}</span>
  </div>
</div>